import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CoreSidebarService} from '../../../../../@core/components/core-sidebar/core-sidebar.service';
import {AlertService} from '../../../../shared/services/alert.service';
import {HttpClient} from '@angular/common/http';
import {GlobalService} from '../../../../shared/services/global.service';
import {UniversityService} from '../../../../shared/services/university.service';
import {StateService} from '../../../../shared/services/state.service';
import {PopularCourseService} from '../../../../shared/services/popular-course.service';
import {PopularCoursesMarketingTagService} from '../../../../shared/services/popular-courses-marketing-tag-service';
import {UniversityMarketingTagService} from '../../../../shared/services/university-marketing-tag.service';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-add-popular-courses-marketing-tag',
    templateUrl: './add-popular-courses-marketing-tag.component.html',
    styleUrls: ['./add-popular-courses-marketing-tag.component.scss']
})
export class AddPopularCoursesMarketingTagComponent implements OnChanges {
    addPopularCourseMarketingTagForm: FormGroup;
    id: any;
    inputTypePassword: any = 'password';
    submitted: any = false;
    submitting: any = false;
    popularCourseId: any;
    @Output() valueSubmitted = new EventEmitter<any>();
    @Input() data: any;

    constructor(private _coreSidebarService: CoreSidebarService,
                private fb: FormBuilder,
                private alertService: AlertService,
                public http: HttpClient,
                public globalService: GlobalService,
                public popularCoursesMarketingTagService: PopularCoursesMarketingTagService,
                private activatedRoute: ActivatedRoute) {
    }

    ngOnChanges(): void {
        this.popularCourseId = this.activatedRoute.snapshot.params['id'];
        this.refresh();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-popular-courses-marketing-tag').toggleOpen();
    }

    refresh() {
        this.addPopularCourseMarketingTagForm = this.fb.group({
            'title': ['', [Validators.required, Validators.pattern(/\S/)]],
            'description': [''],
            'keywords': [''],
            'canonical': [''],
            'author': [''],

        });
        if (this.data && this.data['id']) {
            this.patchForm();
        }
    }

    patchForm() {
        this.addPopularCourseMarketingTagForm.patchValue({
            'title': (this.data && this.data['title']) ? this.data['title'] : '',
            'description': (this.data && this.data['description']) ? this.data['description'] : '',
            'keywords': (this.data && this.data['keywords']) ? this.data['keywords'] : '',
            'canonical': (this.data && this.data['canonical']) ? this.data['canonical'] : '',
            'author': (this.data && this.data['author']) ? this.data['author'] : '',
        });
    }

    submit() {
        this.submitted = true;
        if (!this.addPopularCourseMarketingTagForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'title': (this.addPopularCourseMarketingTagForm.value && this.addPopularCourseMarketingTagForm.value.title) ? this.addPopularCourseMarketingTagForm.value.title : '',
                'description': (this.addPopularCourseMarketingTagForm.value && this.addPopularCourseMarketingTagForm.value.description) ? this.addPopularCourseMarketingTagForm.value.description : '',
                'keywords': (this.addPopularCourseMarketingTagForm.value && this.addPopularCourseMarketingTagForm.value.keywords) ? this.addPopularCourseMarketingTagForm.value.keywords : '',
                'canonical': (this.addPopularCourseMarketingTagForm.value && this.addPopularCourseMarketingTagForm.value.canonical) ? this.addPopularCourseMarketingTagForm.value.canonical : '',
                'author': (this.addPopularCourseMarketingTagForm.value && this.addPopularCourseMarketingTagForm.value.author) ? this.addPopularCourseMarketingTagForm.value.author : '',
            };
            this.submitting = true;
            this.popularCoursesMarketingTagService.create(this.popularCourseId, params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                    this.valueSubmitted.emit(true);
                    this.addPopularCourseMarketingTagForm.reset();
                    this.addPopularCourseMarketingTagForm.patchValue({
                        'title': '',
                        'description': '',
                        'keywords': '',
                        'canonical': '',
                        'author': '',
                    });
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].title && error['error']['errors'].title.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].title[0]);
                        return;
                    }
                }
            });
        }
    }

    update() {
        this.submitted = true;
        if (!this.addPopularCourseMarketingTagForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'title': (this.addPopularCourseMarketingTagForm.value && this.addPopularCourseMarketingTagForm.value.title) ? this.addPopularCourseMarketingTagForm.value.title : '',
                'description': (this.addPopularCourseMarketingTagForm.value && this.addPopularCourseMarketingTagForm.value.description) ? this.addPopularCourseMarketingTagForm.value.description : '',
                'keywords': (this.addPopularCourseMarketingTagForm.value && this.addPopularCourseMarketingTagForm.value.keywords) ? this.addPopularCourseMarketingTagForm.value.keywords : '',
                'canonical': (this.addPopularCourseMarketingTagForm.value && this.addPopularCourseMarketingTagForm.value.canonical) ? this.addPopularCourseMarketingTagForm.value.canonical : '',
                'author': (this.addPopularCourseMarketingTagForm.value && this.addPopularCourseMarketingTagForm.value.author) ? this.addPopularCourseMarketingTagForm.value.author : '',
            };
            this.submitting = true;
            this.popularCoursesMarketingTagService.update(this.data['id'], params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.valueSubmitted.emit(true);
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].title && error['error']['errors'].title.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].title[0]);
                        return;
                    }
                }
            });
        }
    }
}
